import firebase from '../services/firebase';
import React from 'react';
import { LogoutOutlined } from '@ant-design/icons';
import { Button, Layout, message } from 'antd';
import { useHistory } from 'react-router-dom';

export const Header: React.FunctionComponent = () => {
  const history = useHistory();

  const logout = () => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        message.info('Successfully logged out');
        history.push('/login');
      })
      .catch((error) => {
        message.info('Failed to log out');
      });
  };

  // Determine if we're in staging environment
  const isStaging = process.env.REACT_APP_FB_PROJECT_ID?.includes('staging');
  const headerBackgroundColor = isStaging ? '#ff8c00' : '#5455ee'; // Orange for staging, blue for production

  return (
    <Layout.Header
      style={{
        paddingLeft: '25px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: headerBackgroundColor
      }}
    >
      <img
        src={`/sway_logo.png`}
        alt={`Sway Logo`}
        width={30}
        height={50}
      />
      <div style={{ display: 'flex', flex: 'auto', flexDirection: 'row', justifyContent: 'start' }}>
        <span style={{ color: '#fff', marginLeft: '20px', fontSize: '1rem' }}>
          Sway Label Manager
        </span>
      </div>
      <Button type="primary" onClick={logout} icon={<LogoutOutlined />}>
        Logout
      </Button>
    </Layout.Header>
  );
};
